import { useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useTranslationApp } from "../../../../lib/i18next";
import { getReactHookFormNestedError } from "../../../../utils/errors";
import { Controller, useController } from "react-hook-form";
import _ from "lodash";
import Button from "../../../Buttons/Button";
import {
  FIELD_REQUIRED,
  BUTTON_EDIT,
  CONFIGURED_SITE_LINKS,
  BUTTON_ADD_SITE_LINK,
} from "../../../../i18n/keysTranslations";
import ModalSiteLinks from "./ModalSiteLinks";

const AdMetaSiteLinksContainer = ({
  label,
  name,
  control,
  language,
  errors = {},
  disabled = false,
}) => {
  const {
    field: { value, onChange },
  } = useController({
    control,
    name,
    defaultValue: [],
  });
  const [modalSiteLinksOpen, setModalSiteLinksOpen] = useState(false);
  const { t } = useTranslationApp();
  const error = getReactHookFormNestedError(errors, name);

  const onToggleModalSiteLinks = () => setModalSiteLinksOpen((prev) => !prev);

  const isEmptySiteLinks = _.isEmpty(value);

  return (
    <Controller
      name={name}
      control={control}
      rules={{
        required: {
          value: true,
          message: t(FIELD_REQUIRED),
        },
      }}
      render={() => (
        <Box>
          <Typography
            variant="body1"
            gutterBottom
            color={error?.message ? "error" : "default"}
          >
            {label}
          </Typography>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
            }}
          >
            {!isEmptySiteLinks && (
              <Box
                sx={{
                  width: "100%",
                }}
              >
                <Typography
                  variant="body2"
                  sx={{
                    mb: 1,
                  }}
                >
                  {t(CONFIGURED_SITE_LINKS, {
                    value: value.length,
                  })}
                </Typography>
                {!disabled && (
                  <Button
                    color="secondary"
                    type="button"
                    onClick={onToggleModalSiteLinks}
                    disabled={disabled}
                  >
                    {t(BUTTON_EDIT)}
                  </Button>
                )}
              </Box>
            )}
            {isEmptySiteLinks && (
              <Button
                type="button"
                onClick={onToggleModalSiteLinks}
                disabled={disabled}
                color="secondary"
              >
                {t(BUTTON_ADD_SITE_LINK)}
              </Button>
            )}
          </Box>
          {error?.message && (
            <Typography variant="body2" color="error">
              {error.message}
            </Typography>
          )}
          {modalSiteLinksOpen && (
            <ModalSiteLinks
              modalOpen={modalSiteLinksOpen}
              onCloseModal={onToggleModalSiteLinks}
              data={value}
              language={language}
              onCallbackSave={(data) => {
                onChange(data);
              }}
            />
          )}
        </Box>
      )}
    />
  );
};

export default AdMetaSiteLinksContainer;
